import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Tooltip as BlueprintTooltip } from '@blueprintjs/core';
const Tooltip = ({
  modifiers = {
    offset: {
      enabled: true,
      offset: '0, 2px'
    }
  },
  ...props
}) => /*#__PURE__*/React.createElement(BlueprintTooltip, _extends({
  modifiers: modifiers
}, props));
export default Tooltip;